import { sessionActions } from './session';
import { devicesActions } from './devices';

const threshold = 10; // Aumentado para 10 por segundo (valor oficial)
const minInterval = 1000; // Reduzido para 1000ms (valor oficial)
const maxInterval = 30000;
const scaleFactor = 1000;

// eslint-disable-next-line no-undef
const debugMode = process.env.NODE_ENV === 'development';
const debugLog = (message) => debugMode && console.log(message);

export default () => (next) => {
  const deviceBuffer = new Map();
  const positionBuffer = new Map();
  let throttled = false;
  let counter = 0;
  let currentInterval = minInterval;

  const flush = () => {
    const start = performance.now();

    const devices = Array.from(deviceBuffer.values());
    const positions = Array.from(positionBuffer.values());

    if (devices.length > 0) {
      next({ type: devicesActions.update.type, payload: devices });
      deviceBuffer.clear();
    }

    if (positions.length > 0) {
      next({ type: sessionActions.updatePositions.type, payload: positions });
      positionBuffer.clear();
    }

    const totalTime = performance.now() - start;
    debugLog(`Flushed ${devices.length} devices, ${positions.length} positions in ${totalTime.toFixed(2)} ms`);
    currentInterval = Math.min(Math.max(totalTime * scaleFactor, minInterval), maxInterval);
  };

  const tick = () => {
    if (throttled) {
      flush();
    }

    const shouldThrottle = (counter * 1000 / currentInterval) > threshold;
    if (throttled !== shouldThrottle) {
      debugLog(`Throttling ${shouldThrottle}`);
      throttled = shouldThrottle;
    }
    counter = 0;
    if (!throttled) currentInterval = minInterval;
    setTimeout(tick, currentInterval);
  };

  setTimeout(tick, currentInterval);

  return (action) => {
    if (action.type !== devicesActions.update.type && action.type !== sessionActions.updatePositions.type) {
      return next(action);
    }

    counter += 1;

    if (throttled) {
      // Bufferizar as atualizações individualmente
      if (action.type === devicesActions.update.type) {
        action.payload.forEach(item => deviceBuffer.set(item.id, item));
      } else if (action.type === sessionActions.updatePositions.type) {
        action.payload.forEach(item => positionBuffer.set(item.deviceId, item));
      }
      return;
    }

    if ((counter * 1000 / currentInterval) > threshold) {
      if (!throttled) debugLog(`Throttling started`);
      throttled = true;
      // Bufferizar a ação atual também
      if (action.type === devicesActions.update.type) {
        action.payload.forEach(item => deviceBuffer.set(item.id, item));
      } else if (action.type === sessionActions.updatePositions.type) {
        action.payload.forEach(item => positionBuffer.set(item.deviceId, item));
      }
      return;
    }

    return next(action);
  };
};